import wixUsers from 'wix-users';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import { sendTele } from 'backend/befunction';
import { shorter } from 'backend/short';

var IDImage;
var IDDocument;
var accountImage;
var accountDocument;
var checkId = false;
var checkAcc = false;

$w.onReady(function () {
	$w('#progressBar1').value = 25;
});

export function radioGroupID_change(event) {
	$w('#uploadID').fileType = $w('#radioGroupID').value;
}

export function radioGroupAccount_change(event) {
	$w('#uploadAccount').fileType = $w('#radioGroupAccount').value;
}

export function button1_click(event) {
	if ($w('#firstName').value.length > 0 &&
		$w('#lastName').value.length > 0 &&
		$w('#datePicker1').value !== null &&
		$w('#location').value.length > 0) {
		$w('#progressBar1').value = 50;
		$w('#box1').hide();
		$w('#box2').show();
	} else {
		if ($w('#firstName').value.length < 1) {
			$w('#firstName').style.backgroundColor = "#facbc8";
		} else {
			$w('#firstName').style.backgroundColor = "#FFFFFF";
		}
		if ($w('#lastName').value.length < 1) {
			$w('#lastName').style.backgroundColor = "#facbc8";
		} else {
			$w('#lastName').style.backgroundColor = "#FFFFFF";
		}
		if ($w('#location').value.length < 1) {
			$w('#location').style.backgroundColor = "#facbc8";
		} else {
			$w('#location').style.backgroundColor = "#FFFFFF";
		}

		console.log($w('#firstName').value, $w('#firstName').value, $w('#datePicker1').value, $w('#location').value);
		$w('#textError').show();
	}
}
var ascii = /^[ -~]+$/;
export function button2_click(event) {
	if ($w('#phone').value.length > 8 &&
		$w('#email').valid &&
		$w('#password').value.length > 7 &&
		ascii.test($w('#password').value) &&
		$w('#checkbox1').checked) {
		$w('#progressBar1').value = 75;
		$w('#box2').hide();
		$w('#box3').show();
	} else {
		if ($w('#phone').value.length < 0 || !$w('#phone').valid) {
			$w('#phone').style.backgroundColor = "#facbc8";
		} else {
			$w('#phone').style.backgroundColor = "#FFFFFF";
		}
		if (!$w('#email').valid) {
			$w('#email').style.backgroundColor = "#facbc8";
		} else {
			$w('#email').style.backgroundColor = "#FFFFFF";
		}
		if (!$w('#password').value.length < 8) {
			$w('#password').style.backgroundColor = "#facbc8";
		} else {
			$w('#password').style.backgroundColor = "#FFFFFF";
		}
		if (!ascii.test($w('#password').value)) {
			$w('#password').style.backgroundColor = "#facbc8";
		} else {
			$w('#password').style.backgroundColor = "#FFFFFF";
		}
		if (!$w('#checkbox1').checked) {
			$w('#checkbox1').style.backgroundColor = "#facbc8";
		} else {
			$w('#checkbox1').style.backgroundColor = "#FFFFFF";
		}
	}
}

export function buttonPrev1_click(event) {
	$w('#progressBar1').value = 25;
	$w('#box2').hide();
	$w('#box1').show();
}

export function buttonPrev2_click(event) {
	$w('#progressBar1').value = 50;
	$w('#box3').hide();
	$w('#box2').show();
}

export async function submit_click(event) {
	let dt = $w('#datePicker1').value;
	dt.setHours(19);

	if (checkId && checkAcc) {
		$w('#submit').disable();
		$w('#spinner3').show();
		let email = $w('#email').value;
		let toInsert = {
			"date": dt,
			"groom": $w('#lastName').value,
			"bride": $w('#firstName').value,
			"reception": $w('#reception').value,
			"hupa": $w('#hupa').value,
			"location": $w('#location').value,
			"email": email.toLowerCase(),
			"fullNameEvent": $w('#firstName').value + " ו" + $w('#lastName').value,
			"imageId": IDImage,
			"documentAcc": accountDocument,
			"documentId": IDDocument,
			"imageAcc": accountImage
		};

		const results = await wixData.insert("events", toInsert);
		let item = results;
		let id = item._id;
		let fullNameEvent = item.fullNameEvent;

		const item2 = await wixData.get("events", id);
		//shrink event url payment page
		let url = "https://www.rsvpevents.co.il/events/" + id;
		const shortlink = await shorter(url);
		item2.shortUrl = shortlink;
		wixData.update("events", item2);

		let phones = [];
		console.log(results);
		console.log(item2, "item2");
		phones.push($w('#phone').value);
		let password = $w('#password').value;

		let contactInfo = {
			"firstName": $w('#lastName').value,
			"lastName": $w('#firstName').value,
			"phones": phones,
			"eventDate": $w('#datePicker1').value,
		};

		//console.log(email,password,phones);
		wixUsers.register(email, password, { contactInfo })
			.then((result) => {
				let resultStatus = result.status;
				sendTele("register", resultStatus.toString());
			}).catch((err) => {
				let errorMsg = err;
				sendTele("register", err);
			});

		$w('#progressBar1').value = 100;
		$w('#boxDone').show();
		$w('#box3').hide();
	} else {
		$w('#submit').enable();
		$w('#spinner3').hide();
		if (!checkAcc) {
			$w('#textAcc').html = '<p class="p3" dir="rtl" style="color:red">*יש להעלות אישור חשבון בנק או צילום של צ׳ק מבוטל אליו יופקדו המתנות.</p>';
			//console.log($w('#textAcc').html);
		} else {
			$w('#textAcc').html = '<p class="p3" dir="rtl" style="color:black">*יש להעלות אישור חשבון בנק או צילום של צ׳ק מבוטל אליו יופקדו המתנות.</p>';
		}
		if (!checkId) {
			$w('#textId').html = '<p style="color:red" class="p3" dir="rtl">*יש להעלות צילום תעודת זהות בלבד (רישיון/תעודה מזהה אחרת לא יאושרו).</p>';
			//	console.log($w('#textId').html);
		} else {
			$w('#textId').html = '<p style="color:black" class="p3" dir="rtl">*יש להעלות צילום תעודת זהות בלבד (רישיון/תעודה מזהה אחרת לא יאושרו).</p>';
		}
	}
}

export function uploadID_change(event) {
	if ($w("#uploadID").value.length > 0) { // site visitor chose a file
		//console.log("Uploading " + $w("#uploadID").value[0].name);
		$w('#spinner').show();
		$w("#uploadID").buttonLabel = "...טוען";
		$w('#submit').disable();
		$w("#uploadAccount").disable();
		$w("#uploadID").startUpload()
			.then((uploadedFile) => {
				//console.log("Upload successful. File is available here:");
				// console.log(uploadedFile.url);
				if ($w('#uploadID').fileType === "Image") {
					IDImage = uploadedFile.url;
					checkId = true;
				} else {
					IDDocument = uploadedFile.url;
					checkId = true;
				}
				$w('#spinner').hide();
				$w("#uploadID").buttonLabel = "!הקובץ עלה בהצלחה";
				$w('#submit').enable();
				$w("#uploadAccount").enable();

			})
			.catch((uploadError) => {
				$w("#uploadID").buttonLabel = "שגיאה! נסו שנית";
				$w('#submit').enable();
				$w("#uploadAccount").enable();
				$w('#spinner').hide();
				//  console.log(uploadError.errorDescription);
			});
	} else { // site visitor clicked button but didn't choose a file
		//console.log("Please choose a file to upload.");
		$w("#uploadID").buttonLabel = "צילום תעודת זהות";
		$w('#submit').enable();

	}
}

export function uploadAccount_change(event) {
	if ($w("#uploadAccount").value.length > 0) { // site visitor chose a file
		// console.log("Uploading " + $w("#uploadAccount").value[0].name);
		$w('#spinnerAcc').show();
		$w("#uploadAccount").buttonLabel = "...טוען";
		$w('#submit').disable();
		$w('#uploadID').disable();
		$w("#uploadAccount").startUpload()
			.then((uploadedFile) => {
				//  console.log(uploadedFile.url);
				if ($w('#uploadAccount').fileType === "Image") {
					accountImage = uploadedFile.url;
					checkAcc = true;
				} else {
					accountDocument = uploadedFile.url;
					checkAcc = true;
				}
				$w('#spinnerAcc').hide();
				$w("#uploadAccount").buttonLabel = "!הקובץ עלה בהצלחה";
				$w('#submit').enable();
				$w('#uploadID').enable();
			})
			.catch((uploadError) => {
				$w("#uploadAccount").buttonLabel = "שגיאה! נסו שנית";
				$w('#submit').enable();
				$w('#uploadID').enable();
				$w('#spinnerAcc').hide();
				// console.log(uploadError.errorDescription);
			});
	} else { // site visitor clicked button but didn't choose a file
		$w("#uploadAccount").buttonLabel = "אישור חשבון";
		$w('#submit').enable();
	}
}

export function buttonDone_click(event) {
	wixWindow.lightbox.close();
}